// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {Colors} from "../../../assets/Colors";
import {fetchGet, fetchPost, fetchPut} from "../../../fetchers";
import {useMutation} from "@tanstack/react-query";
import {DynamicTableSimple} from "../../../components/tablecard/DynamicTable";
import {Card} from "@material-tailwind/react";
import {isRequired, useForm} from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import {HrdInputGenerator} from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import 'react-toastify/dist/ReactToastify.css';
import {toast} from "react-toastify";
import {BiArrowBack} from "react-icons/bi";
import {useLocation, useNavigate, useParams} from "react-router-dom";

// Fungsi untuk ekstrak nama file dari UUID format
const extractFileName = (fileString) => {
    if (!fileString) return "";

    // Jika format: UUID-namafile.ext
    if (fileString.includes("-")) {
        const parts = fileString.split("-");
        // Ambil bagian setelah UUID (bagian pertama)
        return parts.slice(1).join("-");
    }

    return fileString;
};

// Fungsi untuk mendapatkan icon berdasarkan tipe file
const getFileIcon = (fileName) => {
    if (!fileName) return "📎";
    const ext = fileName.split(".").pop().toLowerCase();
    if (["pdf"].includes(ext)) return "📄";
    if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "🖼️";
    if (["doc", "docx"].includes(ext)) return "📝";
    return "📎";
};

const ApprovalKasBankPage = ({}) => {
    let initialState = {
        BisnisUnitID: "",
        Tanggal: new Date(),
        File: "",
    };

    let initialStateModal = {
        SDTDate: new Date()
    };
    const validations = [
        ({UserPCName}) => isRequired(UserPCName) || {UserPCName: "Nama UserPC wajib diisi"},
        ({Status}) => isRequired(Status) || {Status: "Status wajib diisi"},
        ({KelompokID}) => isRequired(KelompokID) || {KelompokID: "Kelompok wajib diisi"},
        ({Status}) => isRequired(Status) || {Status: "Kelompok wajib diisi"},
        ({DetailAccountID}) => isRequired(DetailAccountID) || {DetailAccountID: "Detail Account wajib diisi"},
        ({Status}) => isRequired(Status) || {Status: "Detail Account wajib diisi"},
    ];

    const {
        changed,
        values,
        isValid,
        touched,
        submitHandler,
        customHandler,
        changeHandler,
        errors,
        blastChange,
        multiFieldHandler
    } = useForm(initialState, validations);

    // Fungsi untuk membuka file attachment
    const getDataFromURL = (url) => {
        if (!url || url.trim() === "") {
            alert("Tidak ada file attachment");
            return;
        }

        // URL encode untuk menghandle karakter khusus
        const encodedUrl = encodeURIComponent(url);

        // Sesuaikan dengan endpoint file server Anda
        const fileUrl = process.env.REACT_APP_API_UPLOAD_URL
            ? `${process.env.REACT_APP_API_UPLOAD_URL}file/${encodedUrl}`
            : `http://192.168.212.24:5000/v1/files/${encodedUrl}`;

        fetch(fileUrl, {
            method: "GET",
            headers: {
                Accept: "application/octet-stream",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.blob();
            })
            .then((blob) => {
                // Buat blob URL
                const fileBlobUrl = window.URL.createObjectURL(blob);

                // Tentukan apakah akan membuka atau download
                if (blob.type.includes("pdf") || blob.type.includes("image")) {
                    // Untuk PDF dan gambar, buka di tab baru
                    window.open(fileBlobUrl, "_blank");
                } else {
                    // Untuk file lain, download
                    const link = document.createElement("a");
                    link.href = fileBlobUrl;

                    // Extract original filename from UUID format
                    let downloadName = url;
                    if (url.includes("-") && url.split("-")[0].length === 36) {
                        const uuidParts = url.split("-");
                        downloadName = uuidParts.slice(1).join("-").replace(/_/g, " ");
                    }

                    link.download = downloadName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // Cleanup blob URL setelah download
                    setTimeout(() => URL.revokeObjectURL(fileBlobUrl), 100);
                }
            })
            .catch((err) => {
                console.error("Error loading file:", err);
                alert("Gagal membuka file. File mungkin belum diupload ke server.");
            });
    };

    const barang = useMutation(formData => fetchGet("Master/Barang/min"))
    const [buttonTouched, setButtonTouched] = useState(false);
    const [detail, setDetail] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    // Modal konfirmasi Approve/Tolak + alasannya. aksiId: "1"=Approve, "2"=Tolak.
    const [showModalAksi, setShowModalAksi] = useState(false);
    const [aksiId, setAksiId] = useState(null);
    const [alasan, setAlasan] = useState("");
    const [modalDetail, setModalDetail] = useState(initialStateModal);
    const [modalID, setModalID] = useState(0);
    const ModalOpener = (detail) => {
        setShowModal(true)
    }
    const param = useLocation();
    const params = useParams();

    const mutation = useMutation(formData => fetchPost("Master/UserPC", formData))
    const mutationAdd = useMutation(formData => fetchPost("Accounting/CashJournal", formData))
    const mutationGet = useMutation(formData => fetchGet("Accounting/CashJournal/" + formData))
    const mutationUpdate = useMutation(formData => fetchPut("Accounting/CashJournal/approval", formData))
    const mutationApproval = useMutation(formData => fetchPost("Accounting/CashJournal/kirim", formData))
    const detailAccount = useMutation(formData => fetchGet("GetMinMasterDetailAccountV2"))

    const ModalEdit = (detail, id) => {
        setModalID(id)
        setModalDetail(detail)
        setShowModal(true)
        setShowModalEdit(true)
    }

    const ModalDelete = (id) => {
        // Array BARU, bukan mutasi in-place — setDetail dgn referensi sama tak
        // memicu re-render (baris "terhapus" tetap tampil, hilang diam2 saat simpan).
        const newDetail = detail.filter((_, i) => i !== id)
        let totals = 0
        newDetail.map(({Nominal}, id) => {
            totals += parseFloat(Nominal)
        })
        customHandler(totals, "Nominal")
        setDetail(newDetail)
    }

    const navigate = useNavigate();

    useEffect(() => {
        detailAccount.mutate()
        barang.mutate()
        if (params.transid) {
            mutationGet.mutate(params.transid.toString().replaceAll("-", "/"))
        }

    }, []);

    useEffect(() => {
        if (mutationUpdate) {
            if (mutationUpdate.isSuccess) {
                navigate("/approval-list")
            }
        }
    }, [mutationUpdate.status]);


    useEffect(() => {
        if (mutationAdd) {
            if (mutationAdd.isSuccess) {
                navigate("/approval-list")
            }
        }
    }, [mutationAdd.status]);
    
    useEffect(() => {
        if (mutationApproval) {
            if (mutationApproval.isSuccess) {
                navigate("/approval-list")
            }
        }
    }, [mutationApproval.status]);
    
    useEffect(() => {
        if (mutationGet.data) {
            let tempData = mutationGet.data.data[0]
            const existingDetail = tempData.Data || [];

            // Dokumen lama bisa punya CashJournalList (lawan) KOSONG -> jurnal satu-sisi
            // dan tak bisa di-approve. Bila detail kosong DAN backend menyarankan akun
            // lawan dari PurchaseOrderID dokumen (LawanAccountID), PRA-ISI satu baris
            // lawan agar approver bisa melengkapi & menyetujui jurnal seimbang.
            // ApproveCashJournal menulis ulang CashJournalList dari payload ini.
            if (existingDetail.length === 0 && tempData.LawanAccountID) {
                setDetail([
                    {
                        Account: tempData.LawanAccountID,
                        Keterangan: tempData.Keterangan || "",
                        Nominal: String(parseFloat(tempData.Nominal) || 0),
                    },
                ]);
                toast.info(
                    "Akun lawan disarankan otomatis dari PO — periksa sebelum approve.",
                    {position: "bottom-right", autoClose: 4000},
                );
            } else {
                setDetail(existingDetail);
            }

            // Set File dari data yang diterima
            if (tempData.File && tempData.File.trim() !== "") {
                customHandler(tempData.File, "File");
            }

            blastChange(tempData)
        }
    }, [mutationGet.status]);

    const header = [
        {name: "Account", key: "Account", modifiers: "Account"},
        {name: "Account Name", key: "Account", modifiers: "AccountName"},
        {name: "Keterangan", key: "Keterangan", modifiers: "Keterangan"},
        {name: "Nominal", key: "Nominal", modifiers: "Numbers"},
        {name: "tools", key: "EditDelete", modifiers: "EditDelete"},
    ]

    // Preview posting jurnal — cerminan PERSIS aturan ApproveCashJournal (backend):
    //   baris kas/bank memakai DetailCashJournal; baris lawan dari detail (CashJournalList).
    //   Pengeluaran / Downpayment PO -> kas/bank di KREDIT, lawan di DEBET; selain itu sebaliknya.
    // Ini menunjukkan ke approver COA apa yang akan terbentuk saat di-approve, sekaligus
    // menandai bila jurnal tak seimbang (mis. detail lawan kosong -> satu sisi saja).
    const namaAkun = (coa) => {
        const list = (detailAccount.data && detailAccount.data.data) || [];
        const found = list.find(({value}) => value === coa);
        return found ? found.label : "";
    };
    const isPengeluaran =
        values.JenisTransaksi === "Pengeluaran" ||
        values.JenisTransaksi === "Downpayment PO";
    const nominalHeader = parseFloat(values.Nominal || 0) || 0;
    const previewRows = [];
    if (values.DetailCashJournal) {
        previewRows.push({
            coa: values.DetailCashJournal,
            nama: namaAkun(values.DetailCashJournal),
            debet: isPengeluaran ? 0 : nominalHeader,
            kredit: isPengeluaran ? nominalHeader : 0,
        });
    }
    (detail || []).forEach((d) => {
        const n = parseFloat(d.Nominal || 0) || 0;
        previewRows.push({
            coa: d.Account,
            nama: namaAkun(d.Account),
            debet: isPengeluaran ? n : 0,
            kredit: isPengeluaran ? 0 : n,
        });
    });
    const previewTotDebet = previewRows.reduce((a, r) => a + r.debet, 0);
    const previewTotKredit = previewRows.reduce((a, r) => a + r.kredit, 0);
    const previewSelisih = previewTotDebet - previewTotKredit;
    const rp = (v) =>
        (parseFloat(v || 0) || 0).toLocaleString("in-ID", {maximumFractionDigits: 0});

    const modalHandler = (value, names) => {
        const newValues = {...modalDetail, [names]: value};
        setModalDetail(newValues);
    };

    const modalHandlerText = (event) => {
        const newValues = {...modalDetail, [event.target.name]: event.target.value};
        setModalDetail(newValues);
    };

    // NumberFormat (react-number-format) memanggil onValueChange dengan objek
    // {formattedValue, value, floatValue} — bukan event DOM — sehingga tampilan
    // boleh berpemisah-ribuan sementara nilai yang disimpan tetap angka murni
    // (pola sama dgn SaldoAwal.js).
    const modalHandlerNominal = (values) => {
        const newValues = {...modalDetail, Nominal: values.floatValue?.toString() || ""};
        setModalDetail(newValues);
    };

    const inputBuilder = [
        {
            type: "DetailAccount",
            name: "Account",
            title: "Account",
            handler: modalHandler,
            size: "full",
            required: false,
            disabled: false,
            edit: false
        },
        {
            type: "text",
            name: "Keterangan",
            title: "Keterangan",
            handler: modalHandlerText,
            size: "full",
            required: false,
            disabled: false,
            edit: false
        },
        {
            type: "numberFormatSatu",
            name: "Nominal",
            title: "Nominal",
            handler: modalHandlerNominal,
            size: "full",
            required: false,
            disabled: false,
            edit: false
        },
    ]


    // Buka modal konfirmasi. Guard keseimbangan dijalankan DI SINI (bukan saat submit)
    // agar approver tak sempat mengetik alasan untuk aksi yang toh akan ditolak.
    const bukaModalAksi = (id) => {
        if (id === "1" && previewSelisih !== 0) {
            toast.error(
                `Tidak bisa approve — jurnal tidak seimbang (selisih ${rp(Math.abs(previewSelisih))}). Samakan total Debet & Kredit dulu.`,
                {position: "bottom-right", autoClose: 5000},
            );
            return;
        }
        setAksiId(id);
        setAlasan("");
        setShowModalAksi(true);
    };

    // Alasan WAJIB saat Tolak, opsional saat Approve. Backend menegakkan aturan yang
    // sama; cek di sini hanya agar approver tahu tanpa round-trip.
    const konfirmasiAksi = () => {
        if (aksiId === "2" && alasan.trim() === "") {
            toast.error("Alasan penolakan wajib diisi.", {
                position: "bottom-right",
                autoClose: 4000,
            });
            return;
        }
        setShowModalAksi(false);
        Kirim(aksiId);
    };

    const Kirim = (id) => {
        let newValues = values;
        try {
            newValues["Nominal"] = newValues["Nominal"].toString()
        } catch (err) {

        }

        newValues["Data"] = detail
        newValues["Status"] = id
        newValues["KeteranganApproval"] = alasan.trim()

        // Kirim File yang sudah ada jika ada
        if (values.File && values.File.trim() !== "") {
            newValues["File"] = values.File;
        }

        mutationUpdate.mutate(newValues)
    }


    return (<div className="md:ml-64">
        <div
            style={{background: Colors.primary}}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 px-4">
                    <Card>
                        <div className="flex flex-col mt-5 p-6">
                            <div className="flex w-full justify-end flex-col sm:flex-row ">
                                <button
                                    onClick={() => navigate("/finance")}
                                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                                >
                                    <BiArrowBack className="text-xl text-gray-800 pr-2"/>
                                    Kembali
                                </button>

                                <button
                                    onClick={() => bukaModalAksi("1")}
                                    disabled={previewSelisih !== 0}
                                    title={previewSelisih !== 0 ? "Jurnal tidak seimbang — tak bisa approve" : ""}
                                    className={`flex flex-row items-center justify-center m-2 sm:my-0 font-semibold py-2 px-4 border shadow rounded ${
                                        previewSelisih !== 0
                                            ? "bg-gray-100 text-gray-400 border-gray-300 cursor-not-allowed"
                                            : "bg-green-100 bg-white hover:bg-main-100 hover:text-white text-gray-800 border-main-100"
                                    }`}
                                >
                                    {mutationUpdate.isLoading ?
                                        <>
                                            <svg aria-hidden="true" role="status"
                                                 className="inline mr-3 w-4 h-4 text-white animate-spin"
                                                 viewBox="0 0 100 101"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="#E5E7EB"/>
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentColor"/>
                                            </svg>
                                            Loading
                                        </>
                                        :
                                        "Approve"
                                    }
                                </button>
                                <button
                                    onClick={() => bukaModalAksi("2")}
                                    className="bg-red-400 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                                >
                                    {mutationUpdate.isLoading ?
                                        <>
                                            <svg aria-hidden="true" role="status"
                                                 className="inline mr-3 w-4 h-4 text-white animate-spin"
                                                 viewBox="0 0 100 101"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                    fill="#E5E7EB"/>
                                                <path
                                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                    fill="currentColor"/>
                                            </svg>
                                            Loading
                                        </>
                                        :
                                        "Tolak"
                                    }
                                </button>
                            </div>
                            {/* Bungkus semua field dalam satu baris flex. Sebelumnya mereka anak
                                langsung dari `flex flex-col`, sehingga w-1/3 & w-1/2 menumpuk
                                menurun dengan lebar ragged (bug sama spt inser-jurnal.js).
                                Field w-full (Attachment) otomatis memaksa baris baru. */}
                            <div className="flex flex-row flex-wrap items-start w-full">
                            <div className="w-1/3">
                                <HrdInputGenerator type={"BisnisUnit"} value={values} name={"BisnisUnitID"}
                                                   title={"Bisnis Unit"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"JenisTransaksiKasBank"} value={values} name={"JenisTransaksi"}
                                                   title={"Jenis Transaksi"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"text"} value={values} name={"DariKepada"}
                                                   title={"Dibayar kepada"}
                                                   onChange={changeHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"JenisPenerimaan"} value={values} name={"JenisCashJournal"}
                                                   title={"Jenis Pembayaran"}
                                                   onChange={(val, name) => {
                                                       // Set Jenis Pembayaran + reset Detail Pembayaran dalam SATU
                                                       // update — dua customHandler beruntun saling menimpa (stale
                                                       // closure) sehingga pilihan Jenis Pembayaran tak pernah tersimpan.
                                                       multiFieldHandler({ [name]: val, DetailCashJournal: "" });
                                                   }} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={false}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"DetailPembayaran"} value={values} name={"DetailCashJournal"}
                                                   title={"Detail Pembayaran"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={false}
                                />
                            </div>
                            <div className="w-1/3">
                                {/* dateOnly memanggil props.onChange(Date, name) — dua argumen —
                                    sehingga WAJIB customHandler. changeHandler membaca
                                    event.target.name, dan Date tidak punya `target`. */}
                                <HrdInputGenerator type={"dateOnly"} value={values} name={"Tanggal"}
                                                   title={"Tanggal"}
                                                   onChange={customHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            {values.NoCek &&
                                <div className="w-1/2">
                                    <HrdInputGenerator type={"text"} value={values} name={"NoCek"}
                                                       title={"No Cek atau bilyed giro"}
                                                       onChange={changeHandler} touched={touched}
                                                       buttonTouched={buttonTouched}
                                                       size={"full"}
                                                       required={true} errors={errors}
                                                       disabled={false}
                                    />
                                </div>
                            }

                            {/* SECTION ATTACHMENT (VIEW ONLY) */}
                            {values.File && values.File.trim() !== "" && (
                                <div className="w-full px-3 mb-4">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Attachment
                                        <span className="text-blue-600 text-xs ml-2">
                                            ✓ File tersedia
                                        </span>
                                    </label>

                                    <div className="flex items-center space-x-2">
                                        {/* Tombol Lihat File */}
                                        <button
                                            type="button"
                                            onClick={() => getDataFromURL(values.File)}
                                            className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 border border-blue-600 rounded shadow-sm"
                                        >
                                            Lihat File
                                        </button>
                                    </div>

                                    {/* Info File - Ekstrak nama file dari field File */}
                                    <div className="mt-2 p-2 bg-gray-50 rounded border">
                                        <div className="flex items-center">
                                            <span className="text-lg mr-2">
                                                {getFileIcon(extractFileName(values.File))}
                                            </span>
                                            <span className="text-sm text-gray-700 truncate">
                                                {extractFileName(values.File)}
                                            </span>
                                        </div>

                                        {/* Info UUID */}
                                        {values.File && values.File.includes("-") && (
                                            <p className="text-xs text-gray-500 mt-1">
                                                UUID: {values.File.split("-")[0]}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="w-1/2">
                                <HrdInputGenerator type={"text"} value={values} name={"Keterangan"}
                                                   title={"Keterangan"}
                                                   onChange={changeHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            <div className="w-1/3">
                                <HrdInputGenerator type={"numberFormatSatu"} value={values} name={"Nominal"}
                                                   title={"Nominal"}
                                                   onChange={changeHandler} touched={touched}
                                                   buttonTouched={buttonTouched}
                                                   size={"full"}
                                                   required={true} errors={errors}
                                                   disabled={true}
                                />
                            </div>
                            </div>
                            <hr/>
                            {/* Master=true menampilkan tombol "Tambah +" (satu-satunya efek
                                Master di DynamicTableSimple) agar approver bisa menambah/menyesuaikan
                                akun lawan. Edit/hapus per baris sudah aktif. ApproveCashJournal
                                menulis ulang CashJournalList dari detail saat di-approve. */}
                            <DynamicTableSimple data={detail}
                                                header={header}
                                                Master={true}
                                                OnClick={ModalOpener}
                                                name={"Purchase Requisition"}
                                                barang={barang.data}
                                                edit={ModalEdit}
                                                delete={ModalDelete}
                                                account={detailAccount.data}
                            />

                            {/* PREVIEW POSTING JURNAL — COA yang akan terbentuk saat di-approve */}
                            <div className="mt-6 px-2">
                                <div className="text-sm font-bold text-gray-700 uppercase mb-2">
                                    Preview Jurnal (akan terbentuk saat di-approve)
                                </div>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full text-sm border border-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="py-2 px-3 text-left font-semibold text-gray-700 border-b">No Akun</th>
                                                <th className="py-2 px-3 text-left font-semibold text-gray-700 border-b">Nama Akun</th>
                                                <th className="py-2 px-3 text-right font-semibold text-gray-700 border-b">Debet</th>
                                                <th className="py-2 px-3 text-right font-semibold text-gray-700 border-b">Kredit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {previewRows.map((r, i) => (
                                                <tr key={i} className="border-b last:border-b-0">
                                                    <td className="py-2 px-3 text-gray-800">{r.coa}</td>
                                                    <td className="py-2 px-3 text-gray-800">{r.nama}</td>
                                                    <td className="py-2 px-3 text-right text-gray-800">{r.debet ? rp(r.debet) : "-"}</td>
                                                    <td className="py-2 px-3 text-right text-gray-800">{r.kredit ? rp(r.kredit) : "-"}</td>
                                                </tr>
                                            ))}
                                            <tr className="font-bold bg-gray-50">
                                                <td className="py-2 px-3" colSpan={2}>TOTAL</td>
                                                <td className="py-2 px-3 text-right">{rp(previewTotDebet)}</td>
                                                <td className="py-2 px-3 text-right">{rp(previewTotKredit)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {previewSelisih !== 0 && (
                                    <div className="mt-2 text-sm font-semibold text-red-600">
                                        ⚠ Jurnal tidak seimbang — selisih {rp(Math.abs(previewSelisih))}.
                                        Lengkapi baris lawan (detail) sebelum meng-approve.
                                    </div>
                                )}
                            </div>
                        </div>
                    </Card>

                    {/* Konfirmasi Approve/Tolak + alasan. Wajib saat Tolak (pengaju perlu
                        tahu apa yang harus diperbaiki), opsional saat Approve. */}
                    <Modal
                        size="sm"
                        active={showModalAksi}
                        toggler={() => setShowModalAksi(false)}
                    >
                        <ModalHeader
                            className="mt-20"
                            toggler={() => setShowModalAksi(false)}
                        >
                            {aksiId === "2" ? "Tolak Dokumen" : "Approve Dokumen"}
                        </ModalHeader>
                        <ModalBody>
                            <div className="w-full">
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    {aksiId === "2"
                                        ? "Alasan penolakan"
                                        : "Catatan persetujuan (opsional)"}
                                    {aksiId === "2" && <span className="text-red-500"> *</span>}
                                </label>
                                <textarea
                                    rows={4}
                                    value={alasan}
                                    onChange={(e) => setAlasan(e.target.value)}
                                    placeholder={
                                        aksiId === "2"
                                            ? "Jelaskan apa yang harus diperbaiki pengaju sebelum mengirim ulang…"
                                            : "Catatan tambahan bila perlu…"
                                    }
                                    className="w-full border border-gray-300 rounded p-2 text-sm focus:outline-none focus:border-main-100"
                                />
                                {aksiId === "2" && alasan.trim() === "" && (
                                    <p className="text-xs text-red-500 mt-1">
                                        Alasan wajib diisi untuk menolak.
                                    </p>
                                )}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="gray"
                                buttonType="link"
                                onClick={() => setShowModalAksi(false)}
                                ripple="dark"
                            >
                                Batal
                            </Button>
                            <Button
                                color={aksiId === "2" ? "red" : "green"}
                                onClick={konfirmasiAksi}
                                ripple="light"
                                disabled={
                                    mutationUpdate.isLoading ||
                                    (aksiId === "2" && alasan.trim() === "")
                                }
                            >
                                {aksiId === "2" ? "Tolak" : "Approve"}
                            </Button>
                        </ModalFooter>
                    </Modal>

                    <Modal
                        size="lg"
                        active={showModal}
                        toggler={() => {
                            setShowModal(true);
                        }}
                    >
                        <ModalHeader
                            className="mt-20"
                            toggler={() => {
                                setShowModal(false);
                                setShowModalEdit(false);
                            }}
                        >

                            {showModalEdit ? "Edit Data" : "Tambah Data"}
                        </ModalHeader>
                        <ModalBody>
                            <form className="w-full " onSubmit={submitHandler}>
                                {inputBuilder.map(({
                                                       type,
                                                       name,
                                                       title,
                                                       handler,
                                                       modifiers,
                                                       size,
                                                       required,
                                                       disabled,
                                                       edit,
                                                   }, id) => {
                                    if (!edit || showModalEdit) {
                                        return (
                                            <HrdInputGenerator type={type} value={modalDetail} name={name} title={title}
                                                               onChange={handler} touched={touched}
                                                               buttonTouched={buttonTouched}
                                                               modifiers={modifiers} size={size}
                                                               required={required} errors={errors}
                                                               disabled={disabled}
                                            />
                                        )
                                    }
                                })}
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="red"
                                buttonType="link"
                                onClick={() => {
                                    setShowModal(false);
                                    setShowModalEdit(false);
                                }}
                                ripple="dark"
                            >
                                Cancel
                            </Button>

                            <Button
                                color={(isValid || (!isValid)) ? "green" : "blueGray"}
                                disabled={mutation.isLoading}
                                onClick={() => {
                                    if (!isValid && changed) {
                                        setButtonTouched(true);
                                    }
                                    let tempIsValid = isValid;
                                    if (!isValid) {
                                    }
                                    if (showModalEdit) {
                                        const newValues = [...detail];
                                        newValues[modalID] = modalDetail
                                        let totals = 0
                                        newValues.map(({Nominal}, id) => {
                                            totals += parseFloat(Nominal)
                                        })
                                        customHandler(totals, "Nominal")
                                        setDetail(newValues);
                                        setModalDetail(initialStateModal)
                                        setShowModal(false)
                                        setShowModalEdit(false)
                                    } else {
                                        const newValues = [...detail, modalDetail];
                                        let totals = 0
                                        newValues.map(({Nominal}, id) => {
                                            totals += parseFloat(Nominal)
                                        })
                                        customHandler(totals, "Nominal")

                                        setDetail(newValues);
                                        setModalDetail(initialStateModal)
                                        setShowModal(false)
                                    }
                                }}
                                ripple={isValid ? "light" : ""}
                            >
                                {showModalEdit ? "Ubah" : "Tambah"}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        </div>
    </div>);
};

export default ApprovalKasBankPage;